module.exports = __webpack_public_path__ + "static/media/2DGACM15.f7a3b32d.jpg";